import { LogoLeagueObjV2, PackageObjV2, PackagesPageV2 } from '@grandstand/presentation-models'
import { SelectedPkg } from '../type/SelectedPkg'

export const getLogosFromPackage = (packages: PackageObjV2[]): LogoLeagueObjV2[] =>
  packages.reduce((acc: LogoLeagueObjV2[], pkg) => {
    pkg.logos.forEach((logo) => {
      acc.push(logo)
    })
    return acc
  }, [])

export const filterUniqueLogos = (logos: LogoLeagueObjV2[]): LogoLeagueObjV2[] => {
  const used: string[] = []
  const uniqueLogos: LogoLeagueObjV2[] = []
  logos.forEach((logo) => {
    if (!used.includes(logo.dark_logo)) {
      used.push(logo.dark_logo)
      uniqueLogos.push(logo)
    }
  })
  return uniqueLogos
}

export const getUniqueLogosFromPackagePage = (pkgs: PackagesPageV2): LogoLeagueObjV2[] => {
  const { available_packages, available_bundles, available_seasonal_packages } = pkgs

  const allLogos: LogoLeagueObjV2[] = [
    ...getLogosFromPackage(available_packages),
    ...getLogosFromPackage(available_bundles),
    ...getLogosFromPackage(available_seasonal_packages),
  ]
  const allUniqueLogos = filterUniqueLogos(allLogos)
  return allUniqueLogos
}

export const resolvePackageResponse = async (
  response: Response,
  isPurchasingDisabled: boolean,
  setIsPurchasingDisabled: React.Dispatch<React.SetStateAction<boolean>>
): Promise<PackagesPageV2> => {
  if (response.status >= 400) {
    if (response.status === 403) {
      const error: { code: string } = await response.json()
      if (error.code === 'purchasing_disabled' && !isPurchasingDisabled) {
        setIsPurchasingDisabled(true)
      }
    }
    return {
      city: null,
      state: null,
      available_bundles: [],
      available_packages: [],
      available_seasonal_packages: [],
      purchased_packages: [],
    }
  }
  if (isPurchasingDisabled) {
    setIsPurchasingDisabled(false)
  }
  return response.json()
}

export const ga4ItemVariantForSelectedPkg = (pkg?: SelectedPkg): string => {
  switch (pkg?.bill_cycle) {
    case undefined:
      return ''
    case 'monthly':
      return 'monthly'
    case 'annual':
      return 'annual'
    default:
      return 'seasonal'
  }
}
